export function useCopyText() {
  const copiedIndex = ref<number | null>(null)

  function extractPlainText(blocks: any): string {
    if (!Array.isArray(blocks)) return ''
    return blocks
      .map((block: any) =>
        Array.isArray(block.children)
          ? block.children.map((span: any) => span.text ?? '').join('')
          : ''
      )
      .join('\n')
  }

  function copyText(blocks: any, index: number) {
    navigator.clipboard.writeText(extractPlainText(blocks)).then(() => {
      copiedIndex.value = index
      setTimeout(() => (copiedIndex.value = null), 1500)
    })
  }

  return { copiedIndex, copyText }
}
